<esr-hero-image-banner></esr-hero-image-banner>

<section class="section">
  <div class="container">
    <esr-navigation></esr-navigation>

    <div class="columns" [class.frontloader]="isNewsPage && !isLoggedIn$">
      <div class="column">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</section>

<esr-footer></esr-footer>